import servicesConfig, { CustomAxiosHeaders } from '../config/services'
import { requests } from '.'
import { AxiosResponse } from 'axios'

// Configure request setup
const serviceName = 'ScoringService'
const host = servicesConfig.Scoring
const opts: CustomAxiosHeaders = { host, serviceName }
const request = (addlOpts?: CustomAxiosHeaders) => {
  return requests(Object.assign({}, opts, addlOpts))
}

// Helper function to handle response
const responseBody = (res: AxiosResponse) => res.data

// Define service object with methods
const ScoringService = {
  getProfiles: async (locationId: string) => 
    request().get(`/profile?locationId=${locationId}`).then(responseBody),

  updateScore: async (body: any) => 
    request().post(`/score`, body).then(responseBody)
}

export default ScoringService